export default function initDataLayer($) {
  /* ========================================================================= *\
  **  === UTILS                                                                *| 
  \* ========================================================================= */

  /* ========================================================================= *\
  **  === DATALAYER                                                            *| 
  \* ========================================================================= */
  // // pageType
  // let $pageType = document.body.classList.contains('home') ? 'home' : document.body.classList.contains('page-template') && !document.body.classList.contains('home') ? 'page' : document.body.classList.contains('single') ? 'product' : 'other'

  // // language
  // const $language = $('html').attr('lang')

  // // env_channel
  // let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // let isTablet = /Tablet|iPad/i.test(navigator.userAgent);
  // let $env_channel = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'

  // // page_cat
  // let segments = location.pathname.split('/');
  // for (let i = 0; i < segments.length; i++) {
  //   let segment = segments[i];
  //   // console.log(segment);
  //   var $page_cat = "Accueil"+segments.slice(0, i + 1).join(' / ');
  // }


  // // debug
  // console.log($pageType)
  // console.log($language)
  // console.log($env_channel)
  // console.log($page_cat)

  // window.dataLayer.push({
  //   "event":"datalayer-loaded",
  //   "pageType" : $pageType,
  //   "language" : $language,
  //   "env_channel" : $env_channel,
  //   "page_cat" : $page_cat
  // });
  

  /*
  *   Datalayer de validation de contact
  */
}
